/**
 * @file   src\Pages\Payment.tsx
 * @brief  Payment page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {
  React,
  useState,
  Button,
  useNavigate,
  Link,
  useParams,
  useEffect,
  Modal,
  useSearchParams,
} from "../utils/thirdpartyComponents";
import CWFooter from "src/components/CWFooter";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import { BayApi } from "src/utils/apiUrls";
import axios from "src/config/axiosConfig";
import {IBayType} from "src/interfaces/bayinterface"
import { pageURLs } from "src/utils/pageUrls";
import SmallLoader from "src/components/SmallLoader";



const SelectBayType = () => {
const params = useParams();
const [searchParams] = useSearchParams();

const navigate = useNavigate();
const [loading,setLoading] =  useState(false);
const [bayTypes,setbayTypes] =  useState<IBayType[]>([]);

  const listBayTypes = async ()=>{
    try {
            setLoading(true); // Show loader
            
              const { data } = await axios.get(BayApi.GET_BAY_TYPES)
              setLoading(false); // Hide loader
              if(data.error === 0)
              {
                setbayTypes(data.data)
              }
            }
          
            catch(e){
              console.log(e)
            }
  }

  const handleClick = (bayTypeId: number) => {
    if (params.carwashname) {
      if(searchParams.get('from')=='signup')
        {
          navigate("/"+params.carwashname+"/"+pageURLs.signupsubscriptionandwashpricelist,{state:{bayTypeId:bayTypeId}});
        }

      else if(bayTypeId==0)
      {

          navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}`);
      }
        
      
      else{
        navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?bayTypeId=${bayTypeId}`);
      }
      
     
    }
  };


  useEffect(() => {
    listBayTypes()
    console.log(bayTypes)
  },[])
  return (
    <div className="common-content-wrap pb-170">
      <div className="inner-content-wrap">
        <div className="common-header two-block-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">
              {/* <Link to={""} className="back-link">
                <img src={Gobackicon} alt="Car Wash App" />
              </Link>{" "} */}
              Select Bay Type
            </div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
          <div className="select-bay-wrap d-flex flex-column">
          {bayTypes ? bayTypes.map((bay) => (
            <Button
              key={bay.bayTypeId}
              variant="primary"
              type="submit"
              className="primary-btn btn-main"
              onClick={() => handleClick(bay.bayTypeId)}
            >
              {bay.bayTypeName}
            </Button>
          )) : ""}
          </div>
        </div>
      </div>
      {loading ? <SmallLoader/> : ""}
      <CWFooter activeLink="Subscriptions" />
    </div>
  );
};

export default SelectBayType;
